import { SET_DSR_FAQ_CONTENT } from "../../actions/dsr-faq-actions-type";


const INITIAL_STATE_DSR_FAQ_PAGE_CONTENT = { results: '' }

export function setDsrFaqContentReducer(state = INITIAL_STATE_DSR_FAQ_PAGE_CONTENT, action) {
    switch (action.type) {
        case SET_DSR_FAQ_CONTENT:
            return { results: action.payload };
        default:
            return state;
    }
}